module.exports = __webpack_public_path__ + "img/grey.006265c8.png";